import * as React from "react";
import styled from "styled-components";

import {
  Text,
  FormLabelRow,
  Checkbox,
  TextInput,
  Toggle,
} from "@hubper/core-ui/elements";
import { SelectBox } from "@hubper/core-ui/components";
import { FormLabel } from "@hubper/core-ui/typo";

function SectionLabel({
  children,
  style,
}: {
  children: any;
  style?: React.CSSProperties;
}) {
  return (
    <Text style={{ marginBottom: 12, ...style }} fs={-1} uppercase fw={"heavy"}>
      {children}
    </Text>
  );
}

const Base = styled.div``;

type Props = {
  availableLanguages: string[];
  selectedLanguages: string[];
  referenceLanguage: string;
  onSelectedLanguagesChange: (language: string, type: "add" | "remove") => void;
  searchString: string;
  onSearchStringChange: (searchString: string) => void;
  showOnlyEmpty: boolean;
  onShowOnlyEmptyChange: (value: boolean) => void;
  onShowNsChange: (ns: string) => void;
  showNs: string;
  availableNamespaces: string[];
};

function Options({
  availableLanguages,
  selectedLanguages,
  onSelectedLanguagesChange,
  referenceLanguage,
  searchString,
  onSearchStringChange,
  showOnlyEmpty,
  onShowOnlyEmptyChange,
  onShowNsChange,
  showNs,
  availableNamespaces,
}: Props) {
  const sortedNamespaces = availableNamespaces
    .map((x) => ({ value: x, display: x }))
    .sort((a, b) => a.display.localeCompare(b.display));

  return (
    <Base>
      <SectionLabel>Show languages</SectionLabel>
      {availableLanguages.map((lang) => {
        const isSelected = selectedLanguages.includes(lang);

        return (
          <FormLabelRow
            key={lang}
            horizontalAlign="top"
            left={<FormLabel>{lang.toUpperCase()}</FormLabel>}
            right={
              <Checkbox
                style={{ opacity: lang === referenceLanguage ? 0.5 : 1 }}
                value={selectedLanguages.includes(lang)}
                onClick={() => {
                  if (lang === referenceLanguage) {
                    return;
                  }
                  onSelectedLanguagesChange(
                    lang,
                    isSelected ? "remove" : "add",
                  );
                }}
              />
            }
            rightWidth={300}
          />
        );
      })}
      <SectionLabel style={{ marginTop: 24 }}>Filters</SectionLabel>
      <TextInput
        label="Search"
        value={searchString}
        onChange={(evt: any) => onSearchStringChange(evt.target.value)}
      />
      <FormLabelRow
        style={{ marginTop: 16 }}
        horizontalAlign="top"
        left={<FormLabel>Show only empty</FormLabel>}
        right={
          <Toggle
            value={showOnlyEmpty}
            onClick={() => {
              onShowOnlyEmptyChange(!showOnlyEmpty);
            }}
          />
        }
        rightWidth={300}
      />
      <SelectBox
        label="Select namespace"
        value={showNs}
        options={[
          { value: "ALL", display: "---Show all---" },
          ...sortedNamespaces,
        ]}
        // @ts-ignore
        onChange={onShowNsChange}
        style={{
          marginTop: 12,
          width: "calc(100% - 34px)",
          boxSizing: "border-box",
        }}
      />
    </Base>
  );
}

export default Options;
